import cashTransfer from "@/api/finance/cash-transfer";
import { baseState, baseMutations } from "@/store/mixins";
import { isEmpty } from "lodash";

export const state = {
    ...baseState,
    employees: [],
    currencies: [],
    banks: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_EMPLOYEES(state, data) {
        state.employees = data;
    },
    SET_CURRENCIES(state, data) {
        state.currencies = data;
    },
    SET_BANKS(state, data) {
        state.banks = data;
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.currentPage,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return cashTransfer.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return cashTransfer.store(data);
    },

    async find(context, id) {
        if (isEmpty(context.state.edit_data)) {
            let response = await cashTransfer.find(id);
            context.commit("SET_EDIT_DATA", response.data);
        }
    },

    update(context, { id, data }) {
        return cashTransfer.update(id, data);
    },

    destroy(context, id) {
        return cashTransfer.destroy(id);
    },

    approveOrReject(context, { id, data }) {
        return cashTransfer.approveOrReject(id, data);
    },

    bankSlip(context, { id, data }) {
        return cashTransfer.bankSlip(id, data);
    },

    photoUpload(context, data) {
        return cashTransfer.photoUpload(data);
    },

    async getEmployees(context) {
        let response = await cashTransfer.employees();
        context.commit("SET_EMPLOYEES", response.data);
    },

    async getCurrencies(context) {
        let response = await cashTransfer.currencies();
        context.commit("SET_CURRENCIES", response.data);
    },

    async getBanks(context) {
        let response = await cashTransfer.banks();
        context.commit("SET_BANKS", response.data);
    }
};
